import { useSyncExternalStore } from 'use-sync-external-store/shim';
import { store } from './store';

export const useSyncProviders = () => useSyncExternalStore(store.subscribe, store.value, store.value);
